import React from 'react'
import { Button, Loader, Icon } from 'semantic-ui-react'
import { fetchAPI } from '@bsd/dashboard-toolkit/utils'


class FileField extends React.Component {

  constructor(props) {
    super(props)
    this.inputRef = React.createRef()
    this.state = {
      loading: false
    }
  }

  handleFileBtn = (e) => {
    e.preventDefault()
    this.inputRef.current.click()
  }

  handleFileSelect = async (e) => {
    if (e) { e.preventDefault() }
    const file = e.target.files[0]
    e.target.value = ''
    if (!file) {
      return
    }
    this.setState({ loading: true })
    if (this.props.value) {
      await fetchAPI(`/in/globe3d/files/delete`, 'POST', { fileUrl: this.props.value.url })
    }
    let fileData = await fetchAPI(`/in/globe3d/files`, 'POST', { file }, true)
    this.setState({ loading: false })
    this.props.onChange(fileData)
  }

  handleDeleteFile = async (e) => {
    if (e) { e.preventDefault() }
    this.props.onChange(null)
  }

  getFileName = name => {
    let nameArray = name.split('/')
    return nameArray[nameArray.length - 1]
  }

  render() {
    const { value } = this.props
    const { loading } = this.state
    return (
      <div>
        <div style={{ marginBottom: '5px' }}>
          <Button
            basic color='blue' size='mini' icon='image'
            content={value ? 'Заменить' : 'Выбрать'}
            onClick={this.handleFileBtn}
          />
          {value && <Button
            basic color='red' size='mini' icon='cancel'
            content='Удалить'
            onClick={this.handleDeleteFile}
          />}
        </div>
        <div>
          {loading
            ? <Loader active inline size="small"/>
            : (<span><Icon name='file outline' color='green'/>{value ? this.getFileName(value.url) : 'Отсутствует'}</span>)}
        </div>
        <input
          type='file'
          style={{ display: 'none' }}
          ref={this.inputRef}
          onChange={this.handleFileSelect}
        />
      </div>
    )
  }

}

export default FileField